import { render, staticRenderFns } from "./Iframed.vue?vue&type=template&id=383ab33c&"
import script from "./Iframed.vue?vue&type=script&lang=js&"
export * from "./Iframed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports